<template>
  <div class="roleSetting">
    <el-container>
      <el-header>
        <el-form ref="form" :model="form" label-width="60px" :inline="true">
          <el-row>
              <el-col :span="6">
                <el-form-item label="所属组织">
                  <el-select v-model="orgId">
                    <el-option
                      :label="post.name"
                      :value="post.id"
                      v-for="post in GovList"
                      :key="post.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            <el-col :span="showAdvanceFilter ? 12 : 6">
              <div class="handlePanel">
                <el-button type="primary" @click="getAllRoles()"
                  >查询</el-button
                >
                <el-button type="info" @click="resetSearch">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <div class="handlePanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addBtnPressed()"
            v-if="btnAuthorize.addBtn.btnEnable"
          >新增</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="updBtnPressed()"
            v-if="btnAuthorize.modifyBtn.btnEnable"
          >修改</el-button>
          <el-button
            type="primary"
            icon="el-icon-delete"
            @click="delBtnPressed()"
            v-if="btnAuthorize.delBtn.btnEnable"
          >删除</el-button>
          <el-button
            type="primary"
            icon="el-icon-tickets"
            @click="assignBtnPressed()"
            v-if="btnAuthorize.menuBtn.btnEnable"
          >菜单授权</el-button>
          <!-- <el-button
            type="primary"
            icon="el-icon-user"
            @click="accountAssignPressed()"
            v-if="btnAuthorize.userBtn.btnEnable"
          >用户授权</el-button>-->
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="roleList"
          highlight-current-row
          size="mini"
          height="100%"
          @current-change="handleSelectionChange"
          @row-click="rowClicked"
          border
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="orgName" label="所属组织" :show-overflow-tooltip="true"></el-table-column> -->
          <!-- <el-table-column prop="isAdmin" label="是否管理员" :show-overflow-tooltip="true">
            <template slot-scope="props">{{props.row.isAdmin==1?'是':'否'}}</template>
          </el-table-column> -->
          <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type" label="角色类型" :show-overflow-tooltip="true">
            <template slot-scope="props">{{props.row.type=='wechat'?'小程序':'普通'}}</template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="roleForm.pageIndex"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="roleForm.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增/修改角色弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAdd?'新增角色':'修改角色'"
      :visible.sync="isAddDialogShow"
      :before-close="closeAddDialog"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" label-width="160px" :rules="addRules">
        <el-row>
          <el-col :span="15">
            <el-form-item label="角色名" prop="name">
              <el-input v-model="addForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="15">
            <el-form-item label="是否管理员">
              <el-select v-model="addForm.isAdmin" :disabled="addForm.type == 'wechat'">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="15">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="addForm.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="角色类型" prop="type">
              <el-select v-model="addForm.type" @change="setUserType">
                <el-option label="普通" value="common"></el-option>
                <el-option label="小程序" value="wechat"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAddDialog">取 消</el-button>
        <el-button type="primary" @click="saveBtnPressed()">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 菜单授权弹窗 -->
    <RoleMenuAssignDialog ref="RoleMenuAssignDialog"></RoleMenuAssignDialog>
    <!-- 用户授权弹窗 -->
    <RoleAccountAssignDialog ref="RoleAccountAssignDialog"></RoleAccountAssignDialog>
  </div>
</template>

<script>
import {
  getEditRolesByUserCodeService,
  addRoleService,
  modifyRoleService,
  getGovService, //组织列表
  deleteRoleService
} from "../../services/sysSettingService";

import { getUserOneLevelDeptService } from "../../services/commonService";
import RoleMenuAssignDialog from "../../components/systemSetting/RoleMenuAssignDialog";
import RoleAccountAssignDialog from "../../components/systemSetting/RoleAccountAssignDialog";

export default {
  name: "roleSetting",
  components: {
    RoleMenuAssignDialog,
    RoleAccountAssignDialog
  },
  data() {
    return {
      total: 0, //角色总数
      roleList: [], //角色列表
      GovList: [], //组织列表
      orgId:'',
      isAddDialogShow: false, //新增角色弹窗显示开关
      isAdd: true, //新增/修改角色标识
      roleSelectedList: [], //选中的角色数组
      deptList: [], //可选组织列表
      menuRoleCode: "", //授权菜单的roleCode
      roleForm: {
        pageIndex: 1,
        pageSize: 10
      },
      addForm: {
        name: "",
        remark: "",
        type: "",
        isAdmin: 0
      },
      addRules: {
        name: [
          { required: true, message: "请输入角色名称" },
          { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        remark: [{ min: 1, max: 60, message: "备注长度必须介于1到60之间" }],
        type: [{required: true, message: "请选择角色类型"}]
        // deptCode: [{ required: true, message: "请选择组织" }]
      },
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        menuBtn: { key: "roleMenu", btnEnable: false } //菜单授权
        // userBtn: { key: "2017111014583055253", btnEnable: false }
      }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  created() {},
  methods: {
    setUserType(val){
      console.log(val)
      if(val == 'wechat'){
        this.addForm.isAdmin = 0;
      }
    },
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.roleForm.pageIndex = 1;
      this.roleForm.pageSize = 10;
      // this.getUserOneLevelDept();
      this.getGovListData(); //获取组织列表
      this.getAllRoles();
    },
    /* 获取角色列表 */
    getAllRoles() {
      this.roleForm.orgId = this.orgId;
      getEditRolesByUserCodeService(this.roleForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.total = res.total;
            this.roleList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 新增角色信息 */
    addRole() {
      // this.addForm.createUserId = sessionStorage.getItem("currentUserId");
      addRoleService(this.addForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("新增成功", "提示", {
              confirmButtonText: "确定"
            });
            this.isAddDialogShow = false;
            this.getAllRoles();
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 修改角色信息 */
    modifyRole() {
      this.addForm.updateUserId = sessionStorage.getItem("currentUserId");
      modifyRoleService(this.addForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示");
            this.isAddDialogShow = false;
            this.getAllRoles();
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 删除角色信息 */
    deleteRole(roleCodes) {
      let reqParam = {
        // userCode: sessionStorage.getItem("userCode"),
        roleId: roleCodes
      };
      deleteRoleService(reqParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.isAddDialogShow = false;
            this.getAllRoles();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
     //获取组织数据列表
     getGovListData() {
      let reqParam = {
        pageIndex: 1,
        pageSize: 100,
        orgId:this.orgId,
      };
      getGovService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.roleForm.pageIndex = page;
      this.getAllRoles();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.roleForm.pageSize = rows;
      this.roleForm.pageIndex = 1;
      this.getAllRoles();
    },
    /* 新增按钮回调 */
    addBtnPressed() {
      this.isAdd = true;
      this.isAddDialogShow = true;
    },
    /* 修改按钮回调 */
    updBtnPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.isAdd = false;
        this.isAddDialogShow = true;
        this.$nextTick(() => {
          this.addForm = Object.assign({}, this.roleSelectedList[0]);
        });
      }
    },
    /* 删除按钮回调 */
    delBtnPressed() {
      if (this.roleSelectedList.length <= 0) {
        this.$alert("请选择一条记录进行删除！", "提示");
      } else {
        this.$confirm("确定删除角色吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // let roles = [];
          // this.roleSelectedList.forEach(role => {
          //   roles.push(role.roleId);
          // });
          let roleId = this.roleSelectedList[0].id;
          this.deleteRole(roleId);
        });
      }
    },
    assignBtnPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].id;
        this.$refs.RoleMenuAssignDialog.refreshMenu(this.menuRoleCode);
      }
    },
    accountAssignPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].roleCode;
        this.$refs.RoleAccountAssignDialog.refreshAccount(this.menuRoleCode);
      }
    },
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate(res => {
        if (res) {
          if (this.isAdd) {
            this.addRole();
          } else {
            this.modifyRole();
          }
        }
      });
    },
    /* 列代表多选回调 */
    handleSelectionChange(roleList) {
      // this.roleSelectedList = roleList;
      this.roleSelectedList = roleList ? [roleList] : [];
    },

    /* 获取新增角色时可选组织 */
    getUserOneLevelDept() {
      getUserOneLevelDeptService(sessionStorage.getItem("userCode")).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.deptList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {
          this.$message.error("系统异常");
        }
      );
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    resetSearch() {
      this.orgId="";
      this.currentPage = 1;
      this.getAllRoles();
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.roleSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
